'use client';

import React from "react";

export default function Footer() {
  return (
    <footer className="bg-black text-background py-3 border-t border-border">
      <div className="container mx-auto px-4 text-center text-sm">
        <p>
          MedFollow &copy; 2025 Desenvolvido por{" "}
          <a
            href="https://pekos.io"
            target="_blank"
            rel="noopener noreferrer"
            className="font-bold hover:underline"
          >
            PEKOS.IO
          </a>
        </p>
      </div>
    </footer>
  );
}
